export const sidebarMenus = [
	{ label: 'Dashboard', path: '/' },
	{ label: 'Negosiasi', path: '/jadwal-negosiasi' },
	{ label: 'Booking', path: '/bookings' },
	{ label: 'Package', path: '/packages' },
	{ label: 'Admins', path: '/admins' },
	{ label: 'Agents', path: '/agents' },
	{ label: 'Settings', path: '/settings' },
];